import Rest from '../Rest'

export default class PhoneService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/phones'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  getAllByPeople(peopleId: Number) {
    return this.get('/all', {people_id:peopleId}).then(data => {
      return data
    })
  }
}
